export default {
  SET_LIST_ORGS(state, payload) {
    state.data = payload.data;
    state.total = payload.total;
    state.count = payload.count;
  },
  SET_QUERY(state, payload) {
    state.query = payload;
  },
  SET_LIST_ORGS_APPEND(state, payload) {
    const items = state.data;
    state.data = items.concat(payload.data);
  },
};
